import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Avatar,
  Grid,
  Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BOOKINGS } from '../../component/common/Routes/AppRoutes';
import { VENDOR_BOOKINGS } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_BOOKINGS } from '../../component/common/Routes/CustomerRoutes';
import '../../styles/SuccessPage.css';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';

const SuccessPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const getBookingsRoute = () => {
    switch (user.role) {
      case 'Admin':
        return BOOKINGS;
      case 'Staff':
        return BOOKINGS;
      case 'Vendor':
        return VENDOR_BOOKINGS;
      case 'Customer':
        return CUSTOMER_BOOKINGS;
      default:
        return BOOKINGS;
    }
  };
  const location = useLocation();
  const pnrNumber = location.state?.pnr_number;
  console.log('pnrNumber', pnrNumber);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);
  return (
    <Box className='success-page'>
      <Container maxWidth='md'>
        <Paper elevation={4} className='success-container fade-in'>
          <Avatar className='success-icon'>
            <CheckCircleIcon sx={{ fontSize: 50 }} />
          </Avatar>

          <Typography variant='h4' className='success-title slide-down'>
            Payment Successful!
          </Typography>

          <Typography
            variant='h6'
            className='success-message slide-down slide-delay-1'
          >
            Your booking has been confirmed. Thank you for choosing our service!
          </Typography>

          <Box className='pnr-section slide-down slide-delay-2'>
            <Typography variant='h6' className='pnr-title'>
              PNR Number :
              <span
                style={{
                  color: 'primary',
                  fontWeight: 'bold',
                }}
              >
                {pnrNumber}
              </span>
            </Typography>
          </Box>

          <Box className='booking-details slide-down slide-delay-2'>
            <Typography variant='h6' className='booking-title'>
              Booking Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color='text.secondary'>
                  A confirmation email has been sent to your registered email
                  address.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {/* <Typography color="text.secondary">
                  You can view your booking details in the "My Bookings"
                  section.
                </Typography> */}
              </Grid>
            </Grid>
          </Box>

          {/* Action Buttons */}
          <Box className='success-button-container slide-down slide-delay-3'>
            <Button
              variant='contained'
              className='view-booking-btn'
              onClick={() => navigate(getBookingsRoute())}
            >
              View Booking
            </Button>
            <Button
              variant='outlined'
              className='return-home-btn'
              onClick={() => navigate('/')}
            >
              Return Home
            </Button>
          </Box>

          {/* Decorative Elements */}
          <Box className='decorative-container'>
            <Box className='decorative-circle-green success-icon' />
            <Box className='decorative-circle-blue success-icon' />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default SuccessPage;
